import { render, staticRenderFns } from "./BarConsultationsISTByJours.vue?vue&type=template&id=45d54ae6&"
import script from "./BarConsultationsISTByJours.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByJours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports